import { render, staticRenderFns } from "./client-certificates.vue?vue&type=template&id=285dad91&"
import script from "./client-certificates.vue?vue&type=script&lang=js&"
export * from "./client-certificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports